import React from 'react';
import DashboardCards from './DashboardCards';
import ComplianceMetrics from './ComplianceMetrics';
import TaskTable from './TaskTable';
import ProjectsTable from './ProjectsTable';
import SourcingAgent from './SourcingAgent';
const Dashboard = () => {
  return <div className="space-y-4" data-id="element-41">
      <div className="flex items-center mb-2" data-id="element-42">
        <h1 className="text-base font-semibold text-gray-800" data-id="element-43">Dashboard</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-44">
        {/* Left column - Cards and Compliance Metrics */}
        <div className="lg:col-span-2 space-y-4" data-id="element-45">
          <DashboardCards data-id="element-46" />
          <SourcingAgent data-id="element-47" />
          <div className="bg-white rounded shadow" data-id="element-48">
            <ComplianceMetrics data-id="element-49" />
          </div>
        </div>
        {/* Right column - Task Table */}
        <div className="lg:col-span-1" data-id="element-50">
          <TaskTable data-id="element-51" />
        </div>
      </div>
      <ProjectsTable data-id="element-52" />
    </div>;
};
export default Dashboard;